/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';
import CloseOutsideBorderComponent from '../../hocs/CloseOutsideBorderComponent';
import DropDownComponent from '../../shared_components/buttons/DropDownComponent';
import ToolOverviewData from '../../../stores/tool/OverviewStore';

@observer
class ColumnSelectComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setFixedRateTerm = this.setFixedRateTerm.bind(this);
  }

  setFixedRateTerm(frt, e) {
    e.stopPropagation();

    const {
      setSortedFixedRateTerm,
      sortLabelInterestsByTermInterest,
      closeOpenSortingDropdown,
    } = this.props.ToolOverviewData;

    setSortedFixedRateTerm(frt);
    closeOpenSortingDropdown();

    /* Reset sortedOverviewTableColumn */
    this.props.ToolOverviewData.sortedOverviewTableColumn = '';

    this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterest(frt,
      this.props.CalculationFormData.labelInterests);
  }

  render() {
    const {
      sortedFixedRateTerm,
      toggleOpenSortingDropdown,
      openSortingDropDown,
      allFixedRateTerms,
    } = this.props.ToolOverviewData;

    let dropDown = '';

    if (openSortingDropDown) {
      const fixedRateTerms = allFixedRateTerms.map((frtItem) => {
        let listItem;

        if (frtItem !== sortedFixedRateTerm) {
          listItem = (
            <div
              onClick={(e) => {
                this.setFixedRateTerm(frtItem, e);
              }}
              className="choose-product-table__dropdown-list-item"
              key={frtItem}
            >
              {frtItem} jaar rentevast
            </div>
          );
        }

        return listItem;
      });

      dropDown = (
        <div className="choose-product-table__dropdown-list">
          {fixedRateTerms}
        </div>
      );
    }

    return (
      <th
        onClick={toggleOpenSortingDropdown}
        colSpan={2}
        className={this.props.classNames}
      >
        {sortedFixedRateTerm} jaar rentevast
        <span className="float-right">
          <DropDownComponent />
        </span>
        <CSSTransitionGroup
          transitionName="slide-down"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={1}
        >
          {dropDown}
        </CSSTransitionGroup>
      </th>
    );
  }
}

ColumnSelectComponent.propTypes = {
  CalculationFormData: PropTypes.shape({
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  classNames: PropTypes.string,
  ToolOverviewData: PropTypes.shape({
    toggleOpenSortingDropdown: PropTypes.func,
    setopenSortingDropDown: PropTypes.func,
    setSortedFixedRateTerm: PropTypes.func,
    sortLabelInterestsByTermInterest: PropTypes.func,
    closeOpenSortingDropdown: PropTypes.func,
    allFixedRateTerms: PropTypes.arrayOf(PropTypes.number),
    fixedRateTerm: PropTypes.number,
    sortedFixedRateTerm: PropTypes.number,
    sortedOverviewTableColumn: PropTypes.string,
    openSortingDropDown: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
  }),
};

ColumnSelectComponent.defaultProps = {
  CalculationFormData: {
    labelInterests: [],
  },
  classNames: '',
  ToolOverviewData: {
    sortedOverviewTableColumn: '',
    sortedFixedRateTerm: '',
    setopenSortingDropDown: () => {},
    sortLabelInterestsByTermInterest: () => {},
    closeOpenSortingDropdown: () => {},
    toggleOpenSortingDropdown: () => {},
    allFixedRateTerms: [],
    fixedRateTerm: '',
    openSortingDropDown: '',
  },
};

export default inject('ToolOverviewData', 'CalculationFormData')(
  CloseOutsideBorderComponent(
    ColumnSelectComponent,
    ToolOverviewData.closeOpenSortingDropdown,
    '.choose-product-table__dropdown-list'));
